import { useOrg } from '@/contexts/OrgContext';

import { useEntitlementScopes } from './useEntitlementScopes';

// Scope name constants — the single source of truth for the frontend.
// Keep in sync with ahoy/entitlements.py SCOPE_* constants.
export const SCOPE_CUSTOM_OBJECTS = 'custom_objects' as const;

/**
 * Check if an entitlement scope is active for the current org.
 *
 * @param scope - The scope name to check (e.g. 'reasoning:advanced')
 * @returns null while loading, true if scope is present, false if absent
 *
 * @example
 * const hasAdvancedReasoning = useHasScope('reasoning:advanced');
 * if (hasAdvancedReasoning === true) {
 *   // Show the feature
 * }
 */
export function useHasScope(scope: string): boolean | null {
  const { currentOrg } = useOrg();
  const { scopes, isLoading } = useEntitlementScopes(currentOrg?.id);
  if (isLoading) {
    return null;
  }
  return scopes.includes(scope);
}
